import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  message: {
    id: 'proforma-form-system.ui.form-card-index.form-card.form-card-header.meatball-spotlight.message',
    defaultMessage: 'You can now edit a form on an issue without it also opening edits in the portal. Select <b>Open customer edits</b> to request customer changes, or select <b>Edit form</b> to update it yourself.',
    description: 'ProForma meatball changeboarding spotlight message explaining the capacity to edit a submitted form within issue view and the dropdown options'
  },
  messageIssueTermRefresh: {
    id: 'proforma-form-system.ui.form-card-index.form-card.form-card-header.meatball-spotlight.message-issue-term-refresh',
    defaultMessage: 'You can now edit a form on a work item without it also opening edits in the portal. Select <b>Open customer edits</b> to request customer changes, or select <b>Edit form</b> to update it yourself.',
    description: 'ProForma meatball changeboarding spotlight message explaining the capacity to edit a submitted form within issue view and the dropdown options'
  },
  ok: {
    id: 'proforma-form-system.ui.form-card-index.form-card.form-card-header.meatball-spotlight.ok',
    defaultMessage: 'OK',
    description: 'ProForma meatball changeboarding spotlight button text.'
  },
  title: {
    id: 'proforma-form-system.ui.form-card-index.form-card.form-card-header.meatball-spotlight.title',
    defaultMessage: 'Control when customers can edit forms in the portal',
    description: 'Proforma meatball changeboarding spotlight title'
  }
});